import {combineReducers} from 'redux';

import foodConsumptionRecuder from './food-consumption/reducer';
import mealPlanRecuder from './meal-plan/reducer';

export default combineReducers({
    foodConsumption: foodConsumptionRecuder,
    mealPlan: mealPlanRecuder,
});
